// extracted by mini-css-extract-plugin
export var browseMoreNav = "schools-grid-module--browseMoreNav--81NU1 typography-module--small--CJ-EH";
export var grid = "schools-grid-module--grid--XvhDS";
export var headline = "schools-grid-module--headline--GiHCB";
export var root = "schools-grid-module--root--AhguE";